"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ERC1967Utils__factory", {
  enumerable: true,
  get: function get() {
    return _ERC1967Utils__factory.ERC1967Utils__factory;
  }
});
var _ERC1967Utils__factory = require("./ERC1967Utils__factory");